import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/phone-hang-up.vue
var s = {
	name: "DtIconPhoneHangUp",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--phone-hang-up"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Phone Hang Up",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M.538 4.006c.84-.668 2.864-2.005 5.62-2.004a8.003 8.003 0 0 1 5.358 2.032c.446.404.396 1.054.017 1.433l-.353-.354.353.354-.726.726c-.339.34-.866.404-1.277.157l-1.076-.646a1.045 1.045 0 0 1-.503-.99l.131-1.45a7.117 7.117 0 0 0-1.924-.262 7.61 7.61 0 0 0-2.096.296v1.49c.001.367-.191.708-.506.897l-1.109.666-.257-.429.257.429a1.045 1.045 0 0 1-1.277-.157l-.701-.701C.066 5.09.045 4.397.538 4.006Zm2.524-.35c-.858.37-1.506.82-1.891 1.124a.047.047 0 0 0 .005.006l.701.7a.045.045 0 0 0 .055.008l1.109-.667a.045.045 0 0 0 .022-.038V3.655Zm5.992-.04-.107 1.188a.045.045 0 0 0 .022.043l1.076.646c.018.01.04.007.055-.007l.726-.726a6.895 6.895 0 0 0-1.772-1.144ZM6 6.237a.5.5 0 0 1 .5.5v2.41l.955-.955a.5.5 0 1 1 .707.707l-1.808 1.808a.5.5 0 0 1-.707 0L3.839 8.899a.5.5 0 1 1 .707-.707l.954.954V6.737a.5.5 0 0 1 .5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=phone-hang-up.js.map